import styled, { css } from 'styled-components'

import LinkImport from '../../Link'

export const SearchContainer = styled.div<{ $show: boolean }>`
  ${({ $show }) =>
    $show
      ? css`
          display: initial;
        `
      : css`
          display: none;
        `};
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 122px;
  overflow: hidden;
  z-index: 5;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 1px 3px 7px 0.5px rgba(11, 11, 11, 0.21);
  @media (min-width: 768px) {
    top: 158px;
  }
  @media (min-width: 992px) {
    top: unset;
    // render below bottom border on NavItem
    margin-top: calc(var(--nav-item-pad-bottom) + var(--nav-item-border-width) + 1px);
  }
`

export const ContentLayout = styled.div`
  display: flex;
  margin: 0 auto;
  width: 100%;
  max-width: 1200px;
  flex-direction: column;
  font-weight: normal;
  letter-spacing: normal;
  overflow: auto;
  padding-bottom: 20px;

  @media (min-width: 768px) {
    padding-bottom: 0;
    flex-direction: row-reverse;
    overflow: unset;
  }
`

export const InvalidSearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: calc(100% - 34px);
`

export const AutoCompleteContainer = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.colors.grayscale.white};
  z-index: 1;
  width: 100%;
  height: 87vh;
  overflow: hidden;
  padding: 24px 15px;
  margin-right: auto;
  margin-left: auto;
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background-color: ${({ theme }) => theme.colors.neutralGray.neutral100};
  }
  ::-webkit-scrollbar {
    width: 8px;
    background-color: ${({ theme }) => theme.colors.neutralGray.neutral100};
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    background-color: ${({ theme }) => theme.colors.neutralGray.neutral600};
  }

  @media (min-width: 768px) {
    max-height: 510px;
  }
`

const suggestItemStyles = css`
  color: ${({ theme }) => theme.colors.neutralGray.neutral600};
  padding: 0.3125rem 0;
  min-height: 90px;
  cursor: pointer;
  font-family: ${({ theme }) => theme.fontFamilies.gothamNarrow};
`

export const SuggestItemList = styled.ul<{ disableScroll?: boolean }>`
  ${suggestItemStyles};
  list-style: none;
  overflow: unset;
  height: 100%;
  max-width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-top: 0;
  margin-bottom: 0;
  cursor: default;
  @media (min-width: 500px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (min-width: 768px) {
    padding-bottom: 26px;
    padding-right: 28px;
    grid-template-columns: repeat(2, 1fr);
    margin-top: inherit;
    margin-bottom: inherit;
    overflow: ${({ disableScroll }) => (disableScroll ? 'unset' : 'auto')};
  }
  @media (min-width: 900px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (min-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (min-width: 1200px) {
    grid-template-columns: repeat(5, 1fr);
  }
`

export const ProductsContainer = styled.div`
  flex: 3;
  overflow-y: unset;

  @media (min-width: 768px) {
    flex: 3;
    overflow-y: hidden;
  }
`

export const SearchTermsContainer = styled.div<{
  $showProducts: boolean
  $showSearchTerms: boolean
}>`
  flex: 1;
  display: ${({ $showSearchTerms }) => ($showSearchTerms ? 'block' : 'none')};
  @media (min-width: 768px) {
    display: ${({ $showProducts, $showSearchTerms }) =>
      $showSearchTerms ? 'block' : $showProducts ? 'block' : 'none'};
    margin-left: 16px;
  }
`

export const CategoriesContainer = styled.div`
  flex: 1;
`

export const SearchTermsAndCategoriesContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: unset;
  overflow: unset;
  margin-bottom: 32px;
  gap: 16px;

  @media (min-width: 768px) {
    margin-bottom: 0;
    min-width: 346px;
    flex: 1.5;
    overflow: hidden;
  }
`

export const Title = styled.h4`
  color: ${({ theme }) => theme.colors.text.primary};
  text-transform: uppercase;
  font-family: Roboto, sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 17.58px;
  text-align: left;
  margin-bottom: 16px;
`

export const CategoriesAndSearchTermsList = styled.ul`
  list-style: none;
  padding-left: 0;
  height: 100%;
  overflow: auto;
  cursor: default;
`
export const CategoriesAndSearchTermsListItem = styled.li`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 18.75px;
  text-align: left;
  text-wrap: wrap;
  padding: 6.5px 0;

  &:hover {
    background-color: ${({ theme }) => theme.colors.coolGray.cool150};
  }
`

export const SuggestItemListEntry = styled.li`
  padding: 5px 0;
`

export const Link = styled(LinkImport)`
  display: inline-block;
  width: 100%;
  height: 100%;
  color: ${({ theme }) => theme.colors.text.secondary};
  text-decoration: none;
  cursor: pointer;
`

export const HighlightedMatch = styled.span`
  color: ${({ theme }) => theme.colors.royalBlue.shade500};
`

export const NoSearchResultsContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.text.primary};
  justify-content: center;
  align-items: center;

  @media (min-width: 768px) {
    flex-direction: row;
    margin-top: 32px;
    margin-bottom: 32px;
    justify-content: flex-start;
    gap: 16px;
    text-align-last: left;
  }
`

export const NoSearchResultsIcon = styled.img`
  width: 44px;
  height: 44px;
  margin-bottom: 16px;
`

export const NoSearchResultsTitle = styled.p`
  font-family: 'Roboto', sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: 23.44px;
  text-align: center;
  margin-bottom: 16px;
`

export const NoSearchResultsSubtitle = styled.h5`
  font-family: 'Gotham', sans-serif;
  font-size: 18px;
  font-weight: bold;
  line-height: 18px;
  text-align: center;
`
